import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Woman } from 'assets/images/women-with-dashboard.svg';
import Button from 'components/Button';
import classNames from 'classnames';
import styles from './GameDetails.module.scss';

const GameDetails = ({ darkTheme, gameCount, mostPlayedGame }) => {
    return (
        <div className={classNames(styles.bodyWrapper, { [styles.darkTheme]: darkTheme })}>
            <Woman aria-hidden="true" />
            <div className={styles.detailsText}>
                <div className={darkTheme ? styles.lightText : styles.helpText}>
                    <div className={styles.img}>
                        Your team's Trivia Stats!
                    </div>
                </div>
                <div className={darkTheme ? styles.lightVisitDashboardText : styles.visitDashboardText}>
                    {gameCount > 0 ? (
                        <>
                            Your team has played {gameCount} games so far on Trivia 🎉
                            <br />
                            Your most played game is {mostPlayedGame} 😁
                        </>
                    ) : (
                        <>
                            Looks like your team hasn’t played any games yet. 
                            <br />
                            Start a Trivia game and make some noise! 😔
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

GameDetails.propTypes = {
  darkTheme: PropTypes.bool,
  gameCount: PropTypes.number,
  mostPlayedGame: PropTypes.string
};

GameDetails.defaultProps = {
    gameCount: 0,
    mostPlayedGame: "Instant Quiz",
    darkTheme: true
};

export default GameDetails;